import { findPreposition } from '@is24at/react-transformers';
import { CountryCode } from '@is24at/react-enums';

const countryNamesWithPreposition = {
  AE: `${findPreposition(CountryCode.AE)} Vereinigten Arabischen Emiraten`,
  AL: `${findPreposition(CountryCode.AL)} Albanien`,
  AT: `${findPreposition(CountryCode.AT)} Österreich`,
  BA: `${findPreposition(CountryCode.BA)} Bosnien-Herzegowina`,
  BE: `${findPreposition(CountryCode.BE)} Belgien`,
  BG: `${findPreposition(CountryCode.BG)} Bulgarien`,
  CH: `${findPreposition(CountryCode.CH)} Schweiz`,
  CY: `${findPreposition(CountryCode.CY)} Zypern`,
  CZ: `${findPreposition(CountryCode.CZ)} Tschechien`,
  ES: `${findPreposition(CountryCode.ES)} Spanien`,
  FR: `${findPreposition(CountryCode.FR)} Frankreich`,
  GR: `${findPreposition(CountryCode.GR)} Griechenland`,
  HR: `${findPreposition(CountryCode.HR)} Kroatien`,
  HU: `${findPreposition(CountryCode.HU)} Ungarn`,
  IT: `${findPreposition(CountryCode.IT)} Italien`,
  LU: `${findPreposition(CountryCode.LU)} Luxemburg`,
  ME: `${findPreposition(CountryCode.ME)} Montenegro`,
  NL: `${findPreposition(CountryCode.NL)} Niederlanden`,
  PL: `${findPreposition(CountryCode.PL)} Polen`,
  PT: `${findPreposition(CountryCode.PT)} Portugal`,
  RO: `${findPreposition(CountryCode.RU)} Rumänien`,
  RU: `${findPreposition(CountryCode.RU)} Russichen Föderation`,
  SI: `${findPreposition(CountryCode.SI)} Slowenien`,
  SK: `${findPreposition(CountryCode.SK)} Slowakei`,
  TR: `${findPreposition(CountryCode.TR)} Türkei`,
};

export const getCountryNameWithPreposition = (countryCode: string) => {
  return countryNamesWithPreposition[countryCode];
};
